export default [
  {
    name: "CurricularPlan",
    title: "Licenciatura em Design",
    subTitle: "departamento de comunicação e arte",
    hasLine: false,
    endpoint: "plan"
  }
];
